import type { Component } from 'svelte';

export const BOTTOM_SHEET_CLOSE_DURATION = 500;
export const MODAL_CLOSE_DURATION = 400;

export interface BottomSheetData {
  isModal?: boolean;
  backdropBlur?: boolean;
  onclose?: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}
let _bottomSheetIsOpen = $state<boolean | null>(null);

let _bottomSheetComponent = $state<Component | undefined>();

let _bottomSheetData = $state<BottomSheetData | undefined>();

export const getBottomSheetComponent = () => {
  return _bottomSheetComponent;
};

export const getBottomSheetData = () => {
  return _bottomSheetData;
};

export const getBottomSheetIsOpen = () => {
  return _bottomSheetIsOpen;
};

export const openModal = (bottomSheet: Component, data?: BottomSheetData) => {
  _bottomSheetComponent = bottomSheet;

  if (data) {
    _bottomSheetData = {
      isModal: true,
      ...data,
    };
  } else {
    _bottomSheetData = {
      isModal: true,
    };
  }

  _bottomSheetIsOpen = true;
};

export const openBottomSheet = (bottomSheet: Component, data?: BottomSheetData) => {
  _bottomSheetComponent = bottomSheet;

  _bottomSheetData = {
    ...data,
  };

  _bottomSheetIsOpen = true;
};

export const closeBottomSheet = async (): Promise<void> => {
  _bottomSheetIsOpen = false;

  await new Promise((resolve) => setTimeout(resolve, BOTTOM_SHEET_CLOSE_DURATION));

  _bottomSheetComponent = undefined;
  _bottomSheetData = undefined;
};

export const closeModal = async (): Promise<void> => {
  _bottomSheetIsOpen = false;

  await new Promise((resolve) => setTimeout(resolve, MODAL_CLOSE_DURATION));

  _bottomSheetComponent = undefined;
  _bottomSheetData = undefined;
};
